import type {
  ClosingTime,
  CreateClosingTimeRequestInput,
  DateOnlyIso,
  DeleteClosingTimeRequestInput,
  UpdateClosingTimeRequestInput,
} from "@luna-restaurant/school-api";

import type { ClosingTimeFormValues } from "@/components/forms/closingTimeFormSchema";

const toDateOnlyIso = (value: string): DateOnlyIso => value as DateOnlyIso;

const withSchoolClass = (schoolClass?: string | null) =>
  schoolClass ? { schoolClass } : {};

export const buildCreateClosingTimeRequestPayload = (
  values: ClosingTimeFormValues,
  schoolScopeValue: string,
): CreateClosingTimeRequestInput => ({
  action: "CREATE",
  name: values.closingNotice,
  startDate: toDateOnlyIso(values.dateFrom),
  endDate: toDateOnlyIso(values.dateTo),
  editedBy: values.editor,
  ...(values.scopeOrClassId !== schoolScopeValue
    ? { schoolClass: values.scopeOrClassId }
    : {}),
});

export const buildUpdateClosingTimeRequestPayload = (
  closingTime: ClosingTime,
  values: ClosingTimeFormValues,
): UpdateClosingTimeRequestInput => ({
  action: "UPDATE",
  name: values.closingNotice,
  startDate: toDateOnlyIso(values.dateFrom),
  endDate: toDateOnlyIso(values.dateTo),
  editedBy: values.editor,
  closingTime: closingTime["@id"],
  ...withSchoolClass(closingTime.schoolClass),
});

export const buildDeleteClosingTimeRequestPayload = (
  closingTime: ClosingTime,
  editedBy: string,
): DeleteClosingTimeRequestInput => ({
  action: "DELETE",
  name: closingTime.name,
  startDate: closingTime.startDate,
  endDate: closingTime.endDate,
  editedBy,
  closingTime: closingTime["@id"],
  ...withSchoolClass(closingTime.schoolClass),
});

export const hasClosingTimeEditChanges = (
  values: ClosingTimeFormValues,
  closingTime: ClosingTime,
): boolean =>
  values.editor.trim() !== (closingTime.editedBy ?? "").trim() ||
  values.closingNotice.trim() !== (closingTime.name ?? "").trim() ||
  values.dateFrom !== closingTime.startDate ||
  values.dateTo !== closingTime.endDate;
